// C:\Projects\texe-web\src\components\Avatar.tsx
import { useEffect, useMemo, useState } from "react";
import { API_BASE_URL } from "../lib/api";

type Props = {
  src?: string | null;
  alt?: string;
  size?: number;           // px (default 32)
  title?: string;
  onClick?: () => void;
  className?: string;

  /** Çerçeve vurgusu: 'ring' seçilirse renkli halka çizer */
  variant?: "default" | "ring";
  ringColor?: string;      // variant="ring" iken çerçeve rengi (default: #ff8a00)
};

function toAbsolute(url?: string | null): string | undefined {
  if (!url) return undefined;
  return url.startsWith("/") ? `${API_BASE_URL}${url}` : url;
}

export default function Avatar({
  src,
  alt,
  size = 32,
  title,
  onClick,
  className,
  variant = "default",
  ringColor = "#ff8a00",
}: Props) {
  const [broken, setBroken] = useState(false);
  const label = (alt ?? "?").trim();
  const letter = (label || "?").charAt(0).toUpperCase();
  const absSrc = useMemo(() => toAbsolute(src), [src]);

  // src değişince kırık durumunu sıfırla
  useEffect(() => {
    setBroken(false);
  }, [absSrc]);

  const borderStyle =
    variant === "ring"
      ? `2px solid ${ringColor}`
      : "1px solid rgba(255,255,255,0.12)";

  return (
    <div
      onClick={onClick}
      role={onClick ? "button" : undefined}
      aria-label={label || "avatar"}
      title={title ?? label}
      className={className}
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        overflow: "hidden",
        border: borderStyle,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: onClick ? "pointer" : "default",
        userSelect: "none",
        background: "rgba(255,255,255,0.06)", // koyu tema dostu
        color: "#ddd",
        lineHeight: 1,
        fontWeight: 700,
      }}
    >
      {!broken && absSrc ? (
        <img
          src={absSrc}
          alt={label || "avatar"}
          loading="lazy"
          decoding="async"
          onError={() => setBroken(true)}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
      ) : (
        <span style={{ fontSize: Math.floor(size * 0.45) }}>{letter}</span>
      )}
    </div>
  );
}
